<template>
  <div class="d-inline">
    <b-button @click="showModal" size="sm" variant="primary">
      <i class="fa fa-edit" aria-hidden="true"></i>
      Add inventory
    </b-button>

    <b-modal
      id="add-inventory-modal"
      ref="add-inventory-modal"
      size="md"
      :ok-title="isSaving ? 'Saving...' : 'Continue'"
      :ok-disabled="isSaving"
      @ok="handleSubmitInventory"
      @hidden="resetForm"
    >
      <template slot="modal-header">
        <h5 class="modal-title">Add inventory</h5>
      </template>

      <form id="add-inventory-form">
        <b-form-group class="required" label="Part number">
          <vue-simple-suggest
            class="suggest-input form-control"
            :class="{ 'is-invalid': $v.partNumber.$error }"
            :styles="autoCompleteStyle"
            :list="getInventories"
            :max-suggestions="10"
            :min-length="3"
            :debounce="200"
            v-model="partNumber"
            :filter-by-query="true"
            value-attribute="id"
            display-attribute="partNumber"
            @select="redirectToInventory"
            @blur="$v.partNumber.$touch()"
            @input="onSuggestChange"
            @request-done="onRequestDone"
          >
            <div slot="misc-item-below" v-if="isLoading" class="misc-item">
              <span>Loading Parts...</span>
            </div>
          </vue-simple-suggest>
          <div v-if="!$v.partNumber.required" class="invalid-feedback">Part number is required</div>
        </b-form-group>
      </form>
      <required-descriptor />
    </b-modal>
  </div>
</template>

<script>
import VueSimpleSuggest from 'vue-simple-suggest';
import { required } from 'vuelidate/lib/validators';

import InventoryService from '@/pages/Inventory/service';

export default {
  name: 'AddInventory',
  components: {
    VueSimpleSuggest,
  },
  data: () => ({
    partNumber: '',
    autoCompleteStyle: {
      vueSimpleSuggest: 'position-relative',
      inputWrapper: '',
      defaultInput: 'form-input full-width form-control',
      suggestions: 'position-absolute list-group z-1000',
      suggestItem: 'list-group-item',
    },
    isLoading: false,
    isSaving: false,
  }),
  methods: {
    showModal: function() {
      this.$root.$emit('bv::show::modal', 'add-inventory-modal', '#btnShow');
    },
    async handleSubmitInventory(e) {
      e.preventDefault();

      this.$v.partNumber.$touch();
      if (this.$v.partNumber.$invalid) {
        return;
      }

      try {
        this.isSaving = true;
        const id = await InventoryService.create(this.partNumber);
        this.isSaving = false;
        this.redirectToInventory({ id });
      } catch (e) {
        this.isSaving = false;
      }
    },
    getInventories: async partNumber => await InventoryService.getMatchedPartNumbers(partNumber),
    redirectToInventory({ id: partId }) {
      this.$router.push({
        name: 'inventory.partDetails',
        params: { partId },
      });
    },
    onSuggestChange() {
      this.isLoading = true;
    },
    onRequestDone() {
      this.isLoading = false;
    },
    resetForm() {
      this.partNumber = '';
      this.$v.$reset();
    },
  },
  validations: {
    partNumber: { required },
  },
};
</script>
